export class SchedulerDate {
	date: Date;
	view: string;
	matchedSchedulers: any[];

	static _getWeekDay(date: Date): string {
		return this._getWeekDayString(date.getDay());
	}

	static _getWeekDayString(weekDay: number): string {
		if (weekDay === 0) {
			return 'SUN';
		} else if (weekDay === 1) {
			return 'MON';
		} else if (weekDay === 2) {
			return 'TUE';
		} else if (weekDay === 3) {
			return 'WED';
		} else if (weekDay === 4) {
			return 'THR';
		} else if (weekDay === 5) {
			return 'FRI';
		} else if (weekDay === 6) {
			return 'SAT';
		} else {
			return 'ERR';
		}
	}
	constructor(date: Date, view: string) {
		this.date = date;
		this.view = view;
		this.matchedSchedulers = [];
	}

	get12Hours(): number {
		if (this.date.getHours() < 12) {
			return this.date.getHours();
		} else {
			return this.date.getHours() - 12;
		}
	}

	getWeekDay(): string {
		return SchedulerDate._getWeekDay(this.date);
	}

	refreshRules(schedules: any[]) {
		this.matchedSchedulers = [];
		if (schedules) {
			schedules.forEach((currentSchedule: any) => {
				const schedule = JSON.parse(JSON.stringify(currentSchedule));
				
				if (schedule.rules && schedule.state === 'Active') {
					for (const scheduleRule of schedule.rules) {
						const rule = scheduleRule.rule;
						if (rule.state === 'Active') {
							let applyFrom = null;
							let applyTo = null;
	
							if (rule.applyFrom && rule.applyTo) {
								applyFrom = new Date(rule.applyFrom).setHours(0);
								applyTo = new Date(rule.applyTo).setHours(0);
							} else {
								applyFrom  = new Date(rule.applyFrom).setHours(0);
								applyTo  = new Date(rule.applyFrom).setHours(0);
							}
							const applyDateDay1 = new Date(applyTo);
							applyTo = applyDateDay1.setDate(applyDateDay1.getDate() + 1);
							if (applyFrom <= this.date && this.date < applyTo) {
								let validDay = false;
	
								if (rule.repeatDayType === 'Day') {
									validDay = true;
								} else if (rule.repeatDayType === 'Week') {
									if (rule.applyDayOfWeek.indexOf(this.getWeekDay()) != -1) {
										validDay = true;
									}
								} else if (rule.repeatDayType === 'Month') {
									if (rule.applyDayOfMonth && Number.parseFloat(rule.applyDayOfMonth) === this.date.getDate()) {
									} else {
										const firstDateOfNextMonth = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
										const endDateOfMonth = new Date(firstDateOfNextMonth.setDate(firstDateOfNextMonth.getDate() - 1));
										if (this.date.getDate() === endDateOfMonth.getDate()) {
											validDay = true;
										}
									}
								} else {
									validDay = true;
								}
								if (validDay) {
									if (this.view === 'Day') {
										let validHour = false;
										if (rule.repeatHourType === 'Hour') {
											const dateHour = ((this.date.getHours() < 10 ? 'H0' : 'H') + String(this.date.getHours()));
											if (rule.applyHourOfDay.indexOf(dateHour) != -1) {
												validHour = true;
											}
										} else {
											if (this.date.getHours() === rule.applyHour) {
												validHour = true;
											}
										}

										if (validHour) {
												if (schedule.taskHistory && schedule.taskHistory.length > 0) {
													schedule.taskHistory.forEach((taskHistory: any) => {
														const executedDate = new Date(taskHistory.executedTime);
		
														if (executedDate.getFullYear() === this.date.getFullYear()
														&& executedDate.getMonth() === this.date.getMonth()
														&& executedDate.getDate() === this.date.getDate()
														&& executedDate.getHours() === this.date.getHours()) {
															schedule.isTaskExecuted = true;
															if (schedule.status !== 'Error') {
																schedule.status = taskHistory.status;
																schedule.result = taskHistory.result;
																schedule.taskHistoryId = taskHistory.id;
															}
														}
													});
												}
												this.matchedSchedulers.push(schedule);
											break;
										}
									} else {
										if (schedule.taskHistory && schedule.taskHistory.length > 0) {
											schedule.taskHistory.forEach((taskHistory: any) => {
												const executedDate = new Date(taskHistory.executedTime);

												if (executedDate.getFullYear() === this.date.getFullYear()
												&& executedDate.getMonth() === this.date.getMonth()
												&& executedDate.getDate() === this.date.getDate()) {
													schedule.isTaskExecuted = true;
													if (schedule.status !== 'Error') {
														schedule.status = taskHistory.status;
														schedule.result = taskHistory.result;
														schedule.taskHistoryId = taskHistory.id;
													}
												}
											});
										}
										this.matchedSchedulers.push(schedule);
										break;
									}
								}
							}								
						}
					}
				}
			});
		}
	}
}
